import { useState } from "react";
import AccordionItem from "../AccordionItem/AccordionItem";
import styles from "./AccordionContainer.module.css";

function AccordionContainer({ data }) {
    const [currentIndex, setCurrentIndex] = useState(-1);
    return (
        <div className={styles.accordion_container}>
            {data.map((d, index) => (
                <AccordionItem
                    currentIndex={currentIndex}
                    setCurrentIndex={setCurrentIndex}
                    index={index}
                    key={d.title}
                    {...d}
                    id={"accordion-item-" + index}
                />
            ))}
        </div>
    );
}

export default AccordionContainer;
